/** Canonical Cursor web URL for a cloud agent conversation. */
export function cursorAgentConversationUrl(agentId: string): string {
  const id = agentId.trim();
  if (!id) return '';
  return `https://cursor.com/agents/${encodeURIComponent(id)}`;
}

/** Prefer API-provided url when it matches the expected host. */
export function resolveCursorAgentUrl(agentId: string, apiUrl?: string): string {
  const fromApi = apiUrl?.trim();
  if (fromApi && /^https:\/\/cursor\.com\/agents\//i.test(fromApi)) {
    return fromApi;
  }
  return cursorAgentConversationUrl(agentId);
}
